import { Dropdown } from 'antd';
import React, { useState } from 'react';
import { makeid } from 'utils/helpers/makeid';

import s from './styles.module.scss';

import type { PatientControlButtonProps } from '../patentControlButton';
import type { MenuProps } from 'antd';
import type { ReactElement, ReactNode } from 'react';

type Option<T = any> = {
  id?: string | boolean | number;
  key?: string;
  label: string | ReactNode;
  value?: T;
  disabled?: boolean;
  handleClick?: (isRpm?: boolean) => void;
};

interface ControlButtonDropdownProps<T = any> {
  options: Option<T>[];
  toggleBtn: ReactElement<PatientControlButtonProps>;
  handleOptionClick?: (value: Option['value']) => void;
  isRpm?: boolean;
}

const ControlButtonDropdown = <T extends any>({
  options,
  toggleBtn,
  handleOptionClick,
  isRpm,
}: ControlButtonDropdownProps<T>) => {
  const [open, setOpen] = useState(false);
  const items: MenuProps['items'] = options.map((option) => ({
    label: option.label,
    key: option.key ?? String(option.id) ?? makeid(5),
    disabled: option.disabled,
    'data-cy': 'select-option',
    onClick: () => {
      handleOptionClick?.(option?.value);
      option?.handleClick?.(isRpm);
    },
  }));

  return (
    <Dropdown
      menu={{ items }}
      trigger={['click']}
      rootClassName={s.menu}
      getPopupContainer={(trigger) => trigger}
      onOpenChange={setOpen}
    >
      <div onClick={(e) => e.preventDefault()}>
        {toggleBtn && React.isValidElement(toggleBtn)
          ? React.cloneElement(toggleBtn, { active: open })
          : toggleBtn}
      </div>
    </Dropdown>
  );
};
export default ControlButtonDropdown;
